import ActionDeleteStakeholderAnalysis from './ActionDeleteStakeholderAnalysis';
import ActionEditStakeholderAnalysis from './ActionEditStakeholderAnalysis';

type StakeholderAnalysisActionsProps = {
  rowId: string;
};

const StakeholderAnalysisActions = ({
  rowId,
}: StakeholderAnalysisActionsProps) => {
  return (
    <>
      <ActionEditStakeholderAnalysis rowId={rowId} />
      <ActionDeleteStakeholderAnalysis rowId={rowId} />
    </>
  );
};

export default StakeholderAnalysisActions;
